import Vue from 'vue';
import Router from 'vue-router';

import Welcome from './views/Welcome';
import Title from './views/Title';
import Entrance from './views/Entrance';
import Board from './views/Board';
import Corridor from './views/Corridor';

Vue.use(Router);

export default new Router({
  routes: [

    /*
      タイトルから玄関まで
     */
    {
      path: '/',
      name: 'welcome',
      component: Welcome
    },
    {
      path: '/title',
      name: 'title',
      component: Title
    },
    {
      path: '/entrance',
      name: 'entrance',
      component: Entrance
    },
    {
      path: '/board',
      name: 'board',
      component: Board
    },

    /*
      廊下
     */
    {
      path: '/corridor',
      component: Corridor,
      children: [

        // A棟 1F
        {path: 'a11n', component: () => import('./views/building_a/Corridor_a_1_1')},
        {path: 'a11s', component: () => import('./views/building_a/Corridor_a_1_1')},
        {path: 'a12n', component: () => import('./views/building_a/Corridor_a_1_2')},
        {path: 'a12s', component: () => import('./views/building_a/Corridor_a_1_2')},
        {path: 'a13e', component: () => import('./views/building_a/Corridor_a_1_3')},
        {path: 'a13s', component: () => import('./views/building_a/Corridor_a_1_3')},

        // B棟 1F
        {path: 'b10e', component: () => import('./views/building_b/Corridor_b_1_0')},
        {path: 'b10w', component: () => import('./views/building_b/Corridor_b_1_0')}
      ]
    },

    /*
      教室
     */
    {
      path: '/library',
      name: 'library',
      component: () => import('./views/building_a/Library')
    },
    {
      path: '/clubroom',
      name: 'clubroom',
      component: () => import('./views/ClubRoom')
    },
    {
      path: '/sportshall',
      name: 'sportshall',
      component: () => import('./views/SportsHall')
    }
  ]
});
